import * as React from 'react';
import { isReactRenderable } from '@rc-component/util';
import { clsx } from 'clsx';
import { useMergeSemantic, useSemanticRootStyle } from '../_util/hooks/useMergeSemantic';
import { useComponentConfig } from '../config-provider/context';
const CardMeta = React.forwardRef((props, ref) => {
    const { prefixCls: customizePrefixCls, className, avatar, title, description, style, classNames: cardMetaClassNames, styles, ...restProps } = props;
    const { getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, } = useComponentConfig('cardMeta');
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const metaPrefixCls = `${prefixCls}-meta`;
    const contextStyleRoot = useSemanticRootStyle(contextStyle);
    const styleRoot = useSemanticRootStyle(style);
    const [mergedClassNames, mergedStyles] = useMergeSemantic([contextClassNames, cardMetaClassNames], [contextStyles, contextStyleRoot, styles, styleRoot], {
        props,
    });
    const rootClassNames = clsx(metaPrefixCls, className, contextClassName, mergedClassNames.root);
    const rootStyles = {
        ...mergedStyles.root,
    };
    const avatarClassNames = clsx(`${metaPrefixCls}-avatar`, mergedClassNames.avatar);
    const titleClassNames = clsx(`${metaPrefixCls}-title`, mergedClassNames.title);
    const descriptionClassNames = clsx(`${metaPrefixCls}-description`, mergedClassNames.description);
    const sectionClassNames = clsx(`${metaPrefixCls}-section`, mergedClassNames.section);
    const avatarDom = isReactRenderable(avatar) ? (React.createElement("div", { className: avatarClassNames, style: mergedStyles.avatar }, avatar)) : null;
    const titleDom = isReactRenderable(title) ? (React.createElement("div", { className: titleClassNames, style: mergedStyles.title }, title)) : null;
    const descriptionDom = isReactRenderable(description) ? (React.createElement("div", { className: descriptionClassNames, style: mergedStyles.description }, description)) : null;
    const MetaDetail = titleDom || descriptionDom ? (React.createElement("div", { className: sectionClassNames, style: mergedStyles.section },
        titleDom,
        descriptionDom)) : null;
    const nativeElementRef = React.useRef(null);
    React.useImperativeHandle(ref, () => ({
        nativeElement: nativeElementRef.current,
    }));
    return (React.createElement("div", { ref: nativeElementRef, ...restProps, className: rootClassNames, style: rootStyles },
        avatarDom,
        MetaDetail));
});
if (process.env.NODE_ENV !== 'production') {
    CardMeta.displayName = 'CardMeta';
}
export default CardMeta;
